import { render, staticRenderFns } from "./marketing-management.vue?vue&type=template&id=347572b7&scoped=true&"
import script from "./marketing-management.vue?vue&type=script&lang=js&"
export * from "./marketing-management.vue?vue&type=script&lang=js&"
import style0 from "./marketing-management.vue?vue&type=style&index=0&id=347572b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347572b7",
  null
  
)

export default component.exports